import {
  Autocomplete,
  AutocompleteChangeReason,
  TextField,
} from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { Vocabulary } from "../../Utils/Vocabulary";
import { InstructorModel, OrderModel, ProductsModel } from "../../Utils/Models";
import { Controller } from "react-hook-form";
import { EditProductProps } from "../../Utils/Types";
import styles from "../../Styles/products.module.css";
import {
  getFullName,
  getSameWidthPopperSlotProps,
  isMobile,
} from "../../Utils/Utils";

export const EditInstructor = (props: EditProductProps) => {
  const [instructors, setInstructors] = useState([] as InstructorModel[]);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const controllerId = props.id ?? "instructor_id";

  /**
   *
   */
  useEffect(() => {
    if (props?.instructors?.length && props?.instructors?.length > 0)
      setInstructors(props.instructors);
  }, [props.instructors]);

  /**
   *
   */
  const mapPropsForProduct = (product: any) => {
    const newProduct = Object.assign({}, new ProductsModel());
    //check product origin (oblio or wordpress)
    newProduct.name = product?.name;

    return newProduct;
  };

  /**
   * Retrieves the instructor object that matches the current controller ID value.
   *
   * This function searches through the list of instructors and finds the one
   * whose ID matches the current value obtained from the form state using the
   * provided controller ID. It returns the matching instructor object or undefined
   * if no match is found.
   *
   * @returns The instructor object that corresponds with the current controller ID,
   *          or undefined if no match is found.
   */

  const getValueForAutocompleteInstructors = () => {
    const value = props.getValues(controllerId);
    if (!value) return null;

    // If value is already a user object with firstName, return it directly
    if (value?.firstName) return value;

    const valueId = typeof value === "string" ? value : value?._id;

    // Try to find by instructorDetails or by direct _id match
    const instructorAsUser = instructors.find((item: any) => {
      const instructorId = item.instructorDetails?.[0]?._id || item._id;
      return instructorId === valueId;
    }) as any;

    return instructorAsUser;
  };

  /**
   *
   */
  return (
    <Fragment>
      <Controller
        name={controllerId}
        control={props.control}
        render={({ fieldState: { error } }) => (
          <>
            <Autocomplete
              id={controllerId}
              disabled={props.disabled}
              fullWidth={true}
              className={styles.editProductOrderOffer}
              freeSolo={false}
              noOptionsText={Vocabulary.noResultsFound}
              slotProps={getSameWidthPopperSlotProps()}
              isOptionEqualToValue={(option: any, value: any) => {
                return option?._id === value?._id || option?._id === value;
              }}
              getOptionLabel={(option: any) => getFullName(option)}
              renderOption={(props, option: any) => (
                <li {...props} key={option._id}>
                  {getFullName(option)}
                </li>
              )}
              options={instructors || []}
              value={
                selectedUser ?? getValueForAutocompleteInstructors() ?? null
              }
              onChange={(
                _e: any,
                product: OrderModel,
                reason: AutocompleteChangeReason,
                details?: any,
              ) => {
                setSelectedUser(product);
                props.onProductChange(
                  _e,
                  mapPropsForProduct(product),
                  reason,
                  details,
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className={styles.editProductOrderOffer}
                  InputProps={{
                    style: {
                      fontWeight: props.isOrderOffer ? "bold" : "normal",
                      ...(props?.applyStyle
                        ? { minWidth: isMobile() ? "100%" : "20vw" }
                        : {}),
                    },
                    ...params.InputProps,
                    rows: 4,
                    multiline: false,
                  }}
                  fullWidth={true}
                  name={controllerId}
                  error={!!error}
                  helperText={error?.message}
                  label={Vocabulary.instructor}
                  variant={props.applyStyle ? "standard" : "outlined"}
                />
              )}
            />
          </>
        )}
      />
    </Fragment>
  );
};
